<template>
  <v-app-bar flat app fixed dark color="primary">
    <v-btn icon height="16px" width="16px" class="ml-2" data-html2canvas-ignore v-if="!['', true].some(p => p === $attrs['no-back'])" @click="goBack">
      <!-- <v-img src="assets/icons/chevron-left.svg" alt="Ícone de voltar" /> -->
    </v-btn>
    <v-spacer />
    <v-toolbar-title @click="gotoHome">
      <!-- <v-img src="assets/imgs/logo-negative.svg" /> -->
    </v-toolbar-title>
    <v-spacer />
    <template v-if="$slots.default" v-slot:extension>
      <slot></slot>
    </template>
  </v-app-bar>
</template>

<script>
export default {
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    },
    goBack () {
      this.$router.back()
    }
  }
}
</script>
